import React, { useState, useEffect } from 'react';
import Card from "@mui/material/Card";
import Modal from '@mui/material/Modal';
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import Table from "examples/Tables/Table";
import axios from "axios";
import { IonLabel } from '@ionic/react'
import SuiButton from "components/SuiButton";
import { FileUploader } from 'react-drag-drop-files';
import { usePapaParse } from "react-papaparse"
import Icon from "@mui/material/Icon";
import { Auth } from "aws-amplify";
import file3 from "./sample.csv"
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import SuiPagination from "components/SuiPagination"; // Import SuiPagination


export const ProjectsPast = (eventName) => {

  const [rows, setrows] = useState([])
  const [datamodal, setdatamodal] = useState()
  const [modal, setmodal] = useState(false);
  const [modal1, setmodal1] = useState(false);
  const [username1, setusername1] = useState("")
  const [title, settitle] = useState();
  const [eventID, setEventID] = useState();
  const [tenant, settenant] = useState("")
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const { readRemoteFile } = usePapaParse();

  const [currentPage, setCurrentPage] = useState(1);  // Current page state
  const [itemsPerPage, setItemsPerPage] = useState(5); // Items per page state
  const [totalPages, setTotalPages] = useState(1);

  //modifiedSAAS
  useEffect(() => {
    Auth.currentUserInfo().then(value => {
      if (value.username == 'admin') {
        settenant("admin")
      }
      else {
        settenant(value.attributes['custom:company'])
      }
    })
  }, [])


  useEffect(() => {
    async function getuser() {
      Auth.currentUserInfo().then(value => {
        setusername1(value.username)
      })
    }
    getuser()
  }, [])


  async function deleteuser(username, file, title) {
    console.log(file);
    await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/EditCSVCertificate", {
      eventname: file,
      username: username
    }).then(value => {
      console.log(title);
      modalshow(file, title);
    });
  }

  async function adduserfn(fullname, username, email, school, phoneNo, achievements) {
    console.log(eventID)
    await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/AddUserCertificate",
      {
        eventname: eventID,
        school_name: school,
        username: username,
        phone_number: phoneNo,
        email: email,
        fullname: fullname,
        achievements: achievements,
        // certid: certid
      }).then(value => {
        console.log(title)
        modalshow(eventID, title)
      })
  }

  const handleEdit = (eventId, eventName) => {
    console.log(`Edit event ${eventId} - ${eventName}`);
    navigate(`/events/${eventId}`, { state: { eventName } });

  };

  async function uploadfile(file, eventID) {
    console.log(eventID);

    try {
      // Get the pre-signed URL for S3
      const uploadUrlResponse = await axios.get(`https://hlsw9m3hud.execute-api.ap-southeast-1.amazonaws.com/default/uploadfile?filename=${eventID}.csv&bucket=certificatesys&typeupload=user`);

      console.log("Sending file to S3...");

      // Upload the file to S3
      await axios.put(uploadUrlResponse.data, file, {
        headers: {
          'Content-Type': 'application/pdf',
        }
      });

      // Call the row function after uploading the file
      row();

      // Send email notification to the participant
      await sendEmailToParticipant(eventID);

    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  async function sendEmailToParticipant(eventID) {
    try {
      await axios.post(`https://hlsw9m3hud.execute-api.ap-southeast-1.amazonaws.com/default/emailUser?filename=${eventID}.csv&bucket=certificatesys&typeupload=user`);
      console.log("Sending email to participant");
    } catch (error) {
      console.error("Failed to send email:", error);
    }
  }


  const handleChange = async (file, name, eventId) => {

    console.log(file)
    console.log(name)

    if (file.name != name + ".csv") {
      alert("CSV File does not meet requirement. Ensure that File is Named " + name + ".csv")
    }
    else {
      uploadfile(file, eventId);
      //importusers(file);
      setmodal(false)
    }
  };

  async function deleteid(id) {
    await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/deleteEvent", {
      ID: id
    }).then(value => {
      row()
    })
  }

  function modalshow(file, title) {
    console.log(title);
    setEventID(file);
    readRemoteFile("https://certificatesys.s3.ap-southeast-1.amazonaws.com/" + file + ".csv" + "?_=" + (new Date).getTime(), {
      complete: (results) => {
        const rowses = [];
        const columns2 = [
          { name: "Name", align: "center" },
          { name: "Username", align: "center" },
          { name: "Achievements", align: "center" },
          { name: "Email", align: "center" },
          { name: "Actions", align: "center" }
        ];
        results.data.forEach(val => {
          if (Object.keys(val).length > 1) {
            rowses.push({
              Name: val["custom:fullname"] || val.fullname,
              Username: val["cognito:username"] || val.ic_number,
              Achievements: val['custom:achievements'] || val.category,
              Email: val.email,
              Actions: <Icon color="error" size="medium" sx={{ fontWeight: "bold", cursor: "pointer" }} onClick={() => { deleteuser(val["cognito:username"] || val.ic_number, file, title) }}>delete</Icon>
            });
          }
        });

        if (rowses.length === 0) {
          setdatamodal(
            <div style={{ marginLeft: "30%", paddingBottom: "20%", paddingTop: "10%" }}>
              <IonLabel>Add Participants</IonLabel>
              <FileUploader handleChange={(e) => { handleChange(e, title, file) }} />
              <a href={file3} download={title + ".csv"}>
                <SuiButton variant="gradient" color="dark" size="small" style={{ marginTop: "50px" }}>
                  <Icon sx={{ fontWeight: "bold", marginRight: "20px" }}>download</Icon>Download CSV Header
                </SuiButton>
              </a>
            </div>
          );
          setmodal(true);
          setmodal1(true);
        } else {
          setdatamodal(<Table columns={columns2} rows={rowses} />);
          setmodal(true);
        }
      },
      download: true,
      header: true,
      error: (er) => {
        console.log(er);
        setdatamodal(
          <div style={{ marginLeft: "30%", paddingBottom: "20%", paddingTop: "10%" }}>
            <IonLabel>Add Participants</IonLabel>
            <FileUploader handleChange={(e) => { handleChange(e, title, file) }} />
            <a href={file3} download={title + ".csv"}>
              <SuiButton variant="gradient" color="dark" size="small" style={{ marginTop: "50px" }}>
                <Icon sx={{ fontWeight: "bold", marginRight: "20px" }}>download</Icon>Download CSV Header
              </SuiButton>
            </a>
          </div>
        );
        setmodal(true);
        setmodal1(true);
      }
    });
  }

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const row = async () => {
    // settitle(eventName)
    await axios.get("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getEvents").then(response => {
      const allEvents = response.data;
      const filteredEvents = allEvents.filter(event => event.tenant === tenant); // Filter events
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const eventsForPage = filteredEvents.slice(startIndex, endIndex); // Slice array to current page

      const eventList = [];
      eventsForPage.forEach(event => {
        if (event.tenant === tenant) {
          eventList.push({
            event: [event.name],
            Date: [event.date],
            Location: [event.location],
            Actions: (
              <>
                <SuiButton
                  variant="text"
                  color="info"
                  size="medium"
                  onClick={() => {
                    settitle(event.name);
                    modalshow(event.id, event.name);
                  }}
                >
                  <Icon>person_add_icon</Icon>
                </SuiButton>
                {/* <SuiButton variant="text" color="error" size="small" onClick={() => {deleteid(certs.id)}}><Icon>delete</Icon></SuiButton> */}
                <SuiButton
                  variant="text"
                  color="success"
                  size="medium"
                  onClick={() => handleEdit(event.id, event.name)}
                >
                  <Icon>edit</Icon>
                </SuiButton>
              </>
            ),
          });
        }
      });
      setrows(eventList);
    });
  };

  const fetchCategories = async () => {
    try {
      const certResponse = await axios.post('https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getCert2', {
        event: eventID,
        tenant,
      });

      // Extracting unique filenames to be used as categories
      const categories = Array.from(new Set(certResponse.data.map(item => item.Category)));
      setCategories(categories);
      console.log(categories);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };


  useEffect(() => {
    async function fetchTotalEvents() {
      const response = await axios.get("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getEvents");
      const allEvents = response.data;
      const filteredEvents = allEvents.filter(event => event.tenant === tenant);
      setTotalPages(Math.ceil(filteredEvents.length / itemsPerPage));
    }

    if (tenant !== "") {
      fetchTotalEvents();
    }
  }, [tenant, itemsPerPage]);


  useEffect(() => {
    //modifiedSAAS
    if (tenant != "") {
      row()
    }
  }, [tenant, currentPage, itemsPerPage])


  function setable() {
    const columns = [
      { name: "event", align: "left" },
      { name: "Date", align: "left" },
      { name: "Location", align: "left" },
      { name: "Actions", align: "center" },
    ];
    setdatamodal(<Table columns={columns} rows={rows} />)
  }

  useEffect(() => {
    if (eventID) {
      fetchCategories();
    }
  }, [eventID]);

  useEffect(() => {
    setable()
    setmodal(false)
    setmodal1(false)
  }, [rows])

  const customStyles = {
    content: {
      // width: "100%",
      // height: '100%',
      top: '70%',
      left: '35%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  function adduserui() {
    setmodal1(true)
    let fullname = ''
    let username = ''
    let email = ''
    let certid = ''
    let achievements = ''
    let school = ''
    let phoneNo = ''
    setdatamodal(
      <SuiBox
        // component="form"
        // role="form"
        // bgColor="light"
        // borderRadius="lg"
        // shadow="lg"
        // opacity={1}
        p={3}
        pt={0}
      // ml={12}
      // mr={12}
      >
        <SuiTypography component="label" fontWeight="bold">
          New User Details
        </SuiTypography>
        <form onSubmit={(e) => {
          e.preventDefault()
          adduserfn(fullname, username, email, school, phoneNo, achievements)
        }}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={6}>
              <SuiBox ml={0.5}>
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Full Name
                </SuiTypography>
              </SuiBox>
              <SuiInput type="text" placeholder="Full Name" onChange={(e) => { fullname = e.target.value }} required />
            </Grid>
            <Grid item xs={12} lg={3}>
              <SuiBox ml={0.5}>
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  IC
                </SuiTypography>
                <SuiInput type="text" placeholder="IC" onChange={(e) => { username = e.target.value }} required />
              </SuiBox>
            </Grid>
            <Grid item xs={12} lg={5}>
              <SuiBox ml={0.5}>
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  School
                </SuiTypography>
              </SuiBox>
              <SuiInput type="text" placeholder="School Name" onChange={(e) => { school = e.target.value }} required />
            </Grid>
            <Grid item xs={12} lg={4}>
              <SuiBox ml={0.5}>
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Phone No
                </SuiTypography>
              </SuiBox>
              <SuiInput type="text" placeholder="Tel No" onChange={(e) => { phoneNo = e.target.value }} required />
            </Grid>
            <Grid item xs={12} lg={4}>
              <SuiBox ml={0.5}>
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Email
                </SuiTypography>
              </SuiBox>
              <SuiInput type="text" placeholder="Email" onChange={(e) => {
                email = e.target.value
              }} required />
            </Grid>
            <Grid item xs={12} lg={4}>
              <SuiBox ml={0.5}>
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Achievements
                </SuiTypography>
              </SuiBox>
              <select className="dropdownInputField" onChange={(e) => { achievements = e.target.value }} required>
                {categories.map(category => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
                {/* <option value="">Select Achievements</option>
              <option value="winner 1">Winner</option>
              <option value="winner 2">First Runner Up</option>
              <option value="winner 3">Second Runner Up</option>
              <option value="participant">Participant</option>
              <option value="finalist">Finalist</option>
              <option value="training">Training</option>
              <option value="advisor">Advisor</option> */}
              </select>
            </Grid>
          </Grid>
          <SuiBox mb={2}>
          </SuiBox>

          <SuiBox mt={4} mb={1}>
            <SuiButton
              color="dark"
              variant="gradient"
              type="submit"
            >
              Add User
            </SuiButton>
          </SuiBox>
        </form>
      </SuiBox>
    )
  }

  if (username1 != "") {
    return (

      <Card>
        <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3} pb={0}>
          <SuiTypography variant="h6" gutterBottom style={{ float: "left" }}>
            {title ? title : "Event List"}
          </SuiTypography>

          <div hidden={!modal}>

            <SuiButton variant="outlined" color="info" size="small" style={{ float: "right" }} onClick={() => {
              row()
              settitle("")
            }
            }>back</SuiButton>

            <div hidden={modal1} style={{ float: "right", marginRight: "20px" }}>
              <SuiButton variant="outlined" color="info" size="small" onClick={adduserui} >Add User</SuiButton>
            </div>
          </div>

        </SuiBox>
        <SuiBox
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) => `${borderWidth[1]} solid ${borderColor}`
              }
            }
          }}
        >
          {datamodal}
        </SuiBox>
        <SuiPagination>
          <SuiPagination item onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            <Icon>keyboard_arrow_left</Icon>
          </SuiPagination>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
            <SuiPagination
              key={pageNumber}
              item
              active={pageNumber === currentPage}
              onClick={() => handlePageChange(pageNumber)}
            >
              {pageNumber}
            </SuiPagination>
          ))}
          <SuiPagination item onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            <Icon>keyboard_arrow_right</Icon>
          </SuiPagination>
        </SuiPagination>
      </Card>
    );
  }
  else {
    return (<></>)
  }
}
